export const docs = [
  {
    name: 'Home',
    url: '/docs/home',
    icon: 'fa fa-home'
  },
  {
    name: 'Create Docs',
    url: '/docs/create',
    icon: 'icon-note'
  },
  {
    title: true,
    name: 'Documents',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: 'Architecture',
    id: 'architecture',
    url: '/docs',
    icon: 'icon-layers',
    children: [
      {
        name: 'Overall',
        url: '/docs/content'
      },
      {
        name: 'Authentication',
        url: '/docs/content'
      },
      {
        name: 'Messaging',
        url: '/dsf'
      }
    ]
  },
  {
    name: 'Deployment',
    id: 'deployment',
    url: '/docs',
    icon: 'cui-cog'
  },
  {
    name: 'Sequence & API',
    id: 'api',
    url: '/docs',
    icon: 'cui-list'
  },
  {
    name: 'Installation',
    id: 'installation',
    url: '/docs',
    icon: 'icon-wrench',
    children: [
      {
        name: 'Firebase',
        url: '/dashboard'
      },
      {
        name: 'Nginx',
        url: '/dashboard'
      },
      {
        name: 'Node & Vue',
        url: '/dashboard'
      }
    ]
  },
  {
    name: 'Tutorial',
    id: 'tutorial',
    url: '/docs',
    icon: 'icon-notebook'
  }
];
